
import { Vector3 } from 'three';
import css from '../../css/toolbox.module.css';
import { toolBoxManagerTemplate } from './toolBoxManagerTemplate';

export class ToolBoxZoneManager extends toolBoxManagerTemplate {
	constructor( modules, managers ) {
		super( modules, managers);
		this.managers.ToolBoxZoneManager = this;
	}

	async init() {
		
		//add css
		this._addStyle( 'toolboxStyle', css );

		document.querySelector( '#toolbox' ).innerHTML = '';
		this.modules.toolbox.init( { containerId: 'toolbox', buttonList: this.#getZoneButtonList() } );

		//add horizontal lines
		this._addVLineAfterButton( 'laterals' );
		
		//hide add/remove zone buttons
		this.toggleButtonVisibility( 'add', false );
		this.toggleButtonVisibility( 'remove', false );

		this.moveSelectedZoneButtons();
	}

	#getZoneButtonList() {
		return this.#getMainButtons()
			.concat( this.#get2Dto3DButton() )
			.concat( this.#getSelectedZoneButtons() );
	}

	#getMainButtons() {
		return [
			{
				title: 'Create Zones',
				containerId: 'utility2DContainer',
				name: 'createZones',
				icon: 'edit',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					this.toggleButton( e, 'edit', 'edit_off' );
					await this.trigger( 'onCreateZones' );
					this.enable( targets.t, targets.c );
				}
			}
		];
	}

	#get2Dto3DButton() {
		return [
			{
				title: 'GoTo3D',
				containerId: 'drawContainer',
				name: 'GoTo3D',
				icon: 'arrow_back',
				label: '',
				callback: async e => {
					//disable button while trigering event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					await this.trigger( 'fromZoneto3D' );
					this.enable( targets.t, targets.c );
				}
			}
		];
	}

	#getSelectedZoneButtons() {
		return [
			{
				title: 'añadir',
				containerId: 'rowBContainer',
				name: 'add',
				icon: 'add',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					//TODO: show modal to select row length
					await this.trigger( 'onAddZone' );
					this.enable( targets.t, targets.c );
				}
			},
			
			{
				title: 'eliminar',
				containerId: 'rowBContainer',
				name: 'remove',
				icon: 'remove',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					//TODO: show modal to select row length
					await this.trigger( 'onDeleteZone' );
					this.enable( targets.t, targets.c );
				}
			}
		];
	}

	toggleButtonVisibility( id, visible = true ) {
		const containers = [ 'utility2DContainer', 'drawContainer', 'rowBContainer' ];
		for( const containerId of containers ) {
			const container = document.querySelector( `#${containerId}` );
			if( !container ) continue;

			const button = container.querySelector( `#${id}` );	
			if( !button ) continue;

			button.style.display = visible ? 'inline-flex' : 'none';
			return;
		}
	}

	moveSelectedZoneButtons() {
		const rowbutton = document.querySelector( '#rowBContainer' );

		const sceneUnit = this.managers.SceneManager.sceneZoneUnit;
		const cells = sceneUnit.grid.getSelectedCells();

		this.toggleButtonVisibility( 'add', cells.length > 0 );
		this.toggleButtonVisibility( 'remove', cells.length > 0 );

		if( cells.length === 0 ) return;

		
		let maxX = 0, maxZ = 0;
		for( const cell of cells ) {
			if( cell.position.x + cell.width / 2 > maxX ) maxX = cell.position.x + cell.width / 2;
			if( cell.position.z + cell.length / 2 > maxZ ) maxZ = cell.position.z + cell.length / 2;
		}
		const rowPos3D = new Vector3( maxX, 0, maxZ );
		const rowPos2D = sceneUnit.toScreenXY( rowPos3D, sceneUnit.camera, sceneUnit.container );

		rowbutton.style.cssText = `
			position: fixed;
			left: ${rowPos2D.x}px;
			top: ${rowPos2D.y}px;
			display: flex;
		`;
	}
}